import styled from "styled-components";

export const ContentContainer = styled.div`
  padding: 1rem;
  overflow-y: auto;
  max-height: calc(100vh - 120px);
`;

export const JobInfoGrid = styled.div`
  display: grid;
grid-template-columns: 1fr;
  gap: 1rem;
  margin-bottom: 1rem;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const JobInfoItem = styled.div<{ $backgroundType?: string }>`
  display: flex;
  align-items: center;
  padding: 1rem;
  background-color: ${props => props.$backgroundType && props.$backgroundType === "jobTitle" ? 'var(--background-main)' : (props.$backgroundType && props.$backgroundType === "jobDescription" ? 'var(--background-alternate)' : 'var(--background-info)')};
  border-radius: 8px;
  margin-top: ${props => props.$backgroundType && props.$backgroundType === "jobDescription" ? '1rem' : '0'};
`;

export const IconWrapper = styled.div<{ $iconType?: string }>`
  margin-right: 1rem;
  color: ${props => props.$iconType && props.$iconType === "role" ? 'var(--info-main)' : 
        (props.$iconType && props.$iconType === "contract" ? 'var(--success-main)' : 
        (props.$iconType && props.$iconType === "startDate" ? 'var(--error-main)' :  
        (props.$iconType && props.$iconType === "experience" ? 'var(--warning-main)' : 
        (props.$iconType && props.$iconType === "jobTitle" ? 'var(--primary-main)' : 'var(--info-main)'))))};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
`;

export const ItemContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ItemTitle = styled.span`
  font-weight: 600;
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 0.25rem;
`;

export const ItemValue = styled.span`
  font-size: 1rem;
  color: #333;
  font-weight: 500;
`;

export const JobDescription = styled.div`
  margin-top: 1rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #333;
  white-space: pre-wrap;
  padding: 1rem;
  border-radius: 8px;
`;

export const CenteredButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1rem;
`;

export const JobTitle = styled.h2`
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 1rem;
`;
